export default {
	default: [''],
	leftLabel: ['input-password--left-label']
};
